package one.healthium.onboarding.ui.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import ifaandroid.feature.onboarding.onboarding_ui.generated.resources.Res
import ifaandroid.feature.onboarding.onboarding_ui.generated.resources.ic_check_16
import ifaandroid.feature.onboarding.onboarding_ui.generated.resources.ic_plus_16
import one.healthium.onboarding.domain.models.SelectableOption
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.modifier.clickableHaptic
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.gray_2
import org.jetbrains.compose.resources.painterResource

@Composable
internal fun SelectableItem(
    option: SelectableOption,
    selected: Boolean,
    userState: UserProfileUiModel,
    onClick: () -> Unit,
    additionalSelectedText: String? = null,
) {
    Box(
        modifier = Modifier
            .testTag("onboarding_option_${option.key}")
            .clip(AppTheme.shapes.small)
            .clickableHaptic { onClick() }
            .background(
                color = if (selected) AppTheme.colors.primary else gray_2,
                shape = AppTheme.shapes.small,
            )
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 16.dp, vertical = 14.dp)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                AppText(
                    modifier = Modifier.weight(1f),
                    text = option.text.value(userState.gender),
                    style = AppTheme.textStyles.body1Medium,
                    color = if (selected) AppTheme.colors.textInverted100 else AppTheme.colors.text100
                )
                Spacer(Modifier.width(8.dp))
                Image(
                    painter = if (selected) painterResource(Res.drawable.ic_check_16) else painterResource(Res.drawable.ic_plus_16),
                    contentDescription = null
                )
            }
            val selectedText = option.additionalSelectedText ?: additionalSelectedText
            if (selected && !selectedText.isNullOrEmpty()) {
                Spacer(Modifier.height(6.dp))
                Text(
                    text = selectedText,
                    style = AppTheme.textStyles.body2,
                    color = AppTheme.colors.textInverted100,
                )
            }
        }
    }
}